import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import Loading from "../../../../Extra/Loading";
import {
  getCurrentFY,
  getFinancialYearMonthsPassed,
} from "../../../../Utilitie";
import CrackMonthlyReportGraph from "../GraphView/CrackMonthlyReportGraph";
import CrackMonthlyTotalGraph from "../GraphView/CrackMonthlyTotalGraph";

const months = [
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "Jan",
  "Feb",
  "Mar",
];

const CrackMonthlyReport = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const tableRef = useRef();
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const currentYear = new Date().getFullYear();
  const defaultFy = `${currentYear - 1}-${currentYear}`;
  const [selectedFy, setSelectedFy] = useState(defaultFy);
  const mpassed = getFinancialYearMonthsPassed(getCurrentFY(), false);
  const [selectedMonths, setSelectedMonths] = useState([...mpassed]);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(
          `${urlPrefix}getMonthwiseCracksHdrData?FyYear=${selectedFy}`,
        );
        if (response.status === "ok" && Array.isArray(response.data)) {
          setData(response.data);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedFy]);

  const sections = data.filter((item) => item.children);
  const fyYearsObj = data.find((item) => item.fyYears);
  const fyYears = fyYearsObj?.fyYears || [];
  const sortedSections = [...sections].sort((a, b) => {
    const getPrevTotal = (section) => {
      const prevData = section.children[0]?.data || [];
      const prevMap = {};

      prevData.forEach((item) => {
        prevMap[item.month_name] = Number(item.total_no_of_crack) || 0;
      });
      return selectedMonths.reduce((sum, m) => sum + (prevMap[m] || 0), 0);
    };

    return getPrevTotal(b) - getPrevTotal(a);
  });

  return (
    <div>
      <h5 className="bg-dark text-white p-2">Crack Month Wise Report</h5>

      <div className="d-flex newUiBody align-items-center gap-3 flex-wrap p-2">
        <select
          className="form-select text-black fw-bolder text-center form-control w-25"
          onChange={(e) => {
            setSelectedFy(e.target.value);
          }}
          value={selectedFy}
        >
          <option value="">Select Financial Year</option>
          {fyYears.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <div
        className="d-flex newUiBody flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 p-3  border rounded shadow-sm"
        style={{ background: "rgba(240, 240, 240, 0.48)" }}
      >
        <div className="d-flex flex-wrap align-items-center gap-2">
          <label className="fw-bold me-2 mb-0">Filter by Months:</label>
          {months.map((month) => {
            const isActive = selectedMonths.includes(month);
            return (
              <span
                key={month}
                className={`badge rounded-pill px-3 py-2 ${
                  isActive ? "bg-primary text-white" : "bg-secondary text-white"
                }`}
                onClick={() =>
                  setSelectedMonths((prev) =>
                    prev.includes(month)
                      ? prev.filter((m) => m !== month)
                      : [...prev, month],
                  )
                }
                style={{ userSelect: "none", cursor: "pointer" }}
              >
                {month}
              </span>
            );
          })}
        </div>

        <div className="d-flex gap-2">
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => setSelectedMonths([...months])}
          >
            Select All
          </button>
          <button
            className="btn btn-sm btn-outline-dark"
            onClick={() => setSelectedMonths([])}
          >
            Deselect All
          </button>
        </div>
      </div>
      <div className="row">
        {" "}
        <div className="col-md-8">
          <CrackMonthlyReportGraph
            data={data}
            sections={sections}
            selectedMonths={selectedMonths}
            months={months}
            selectedFy={selectedFy}
          />
        </div>{" "}
        <div className="col-md-4">
          <CrackMonthlyTotalGraph
            data={data}
            sections={sections}
            selectedMonths={selectedMonths}
            months={months}
            selectedFy={selectedFy}
          />
        </div>
      </div>

      <div
        className="table-wrapper table-responsive"
        style={{ maxHeight: "500px", overflowY: "auto" }}
      >
        {loading && <Loading />}

        <table
          ref={tableRef}
          border="1"
          cellPadding="8"
          className="table  table-hover table-striped table-bordered"
          style={{ fontSize: "13px" }}
        >
          <thead className="table-dark text-center sticky-top">
            <tr>
              <th rowSpan={2} className="align-middle">
                Section Name
              </th>
              <th colSpan={selectedMonths.length}>
                Previous Year ({selectedFy.replace(/\d+/g, (y) => +y - 1)})
              </th>
              {selectedMonths.length > 0 && (
                <th rowSpan={2} className="align-middle">
                  Total
                </th>
              )}
              <th colSpan={selectedMonths.length}>
                Current Year ({selectedFy})
              </th>
              {selectedMonths.length > 0 && (
                <th rowSpan={2} className="align-middle">
                  Total
                </th>
              )}

              <th colSpan={selectedMonths.length}>Variation Percentage</th>
              {selectedMonths.length > 0 && (
                <th rowSpan={2} className="align-middle">
                  V/P Total
                </th>
              )}
            </tr>
            <tr>
              {selectedMonths.map((m) => (
                <th key={`head-prev-${m}`}>{m}</th>
              ))}
              {selectedMonths.map((m) => (
                <th key={`head-curr-${m}`}>{m}</th>
              ))}

              {selectedMonths.map((m) => (
                <th key={`head-var-${m}`}>{m} %</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {sortedSections.map((section, i) => {
              const prevYearData = {};
              const currYearData = {};

              const prevData = section.children[0]?.data || [];
              const currData = section.children[1]?.data || [];

              prevData.forEach((item) => {
                prevYearData[item.month_name] =
                  Number(item.total_no_of_crack) || 0;
              });

              currData.forEach((item) => {
                currYearData[item.month_name] =
                  Number(item.total_no_of_crack) || 0;
              });

              let prevTotal = 0;
              let currTotal = 0;

              selectedMonths.forEach((m) => {
                prevTotal += prevYearData[m] || 0;
                currTotal += currYearData[m] || 0;
              });

              let totalVariation = ((currTotal - prevTotal) * 100) / prevTotal;
              totalVariation = !isFinite(totalVariation) ? 0 : totalVariation;

              return (
                <tr key={`section-${i}`}>
                  <td className="table-dark">{section.section_name}</td>

                  {selectedMonths.map((m, j) => (
                    <td key={`prev-${i}-${j}`}>{prevYearData[m] || 0}</td>
                  ))}

                  <td className="fw-bold bg-secondary text-white text-center">
                    {prevTotal}
                  </td>

                  {selectedMonths.map((m, j) => (
                    <td key={`curr-${i}-${j}`}>{currYearData[m] || 0}</td>
                  ))}

                  <td className="fw-bold bg-secondary text-white text-center">
                    {currTotal}
                  </td>

                  {selectedMonths.map((m, j) => {
                    const prev = prevYearData[m] || 0;
                    const curr = currYearData[m] || 0;
                    let percentage = ((curr - prev) * 100) / prev;
                    percentage = !isFinite(percentage) ? 0 : percentage;

                    return (
                      <td key={`var-${i}-${j}`}>
                        <div
                          className="m-1 text-center p-1"
                          style={{
                            borderRadius: "5px",
                            background:
                              percentage > 0
                                ? "rgba(88, 223, 61, 0.78)"
                                : "rgba(233, 75, 75, 0.9)",
                            color: "black",
                          }}
                        >
                          {percentage > 0 ? (
                            <BsFillCaretUpFill />
                          ) : (
                            <BsFillCaretDownFill />
                          )}
                          {percentage.toFixed(1)}
                        </div>
                      </td>
                    );
                  })}

                  <td className="fw-bold bg-dark text-center">
                    <div
                      className="m-1 text-center p-1"
                      style={{
                        borderRadius: "5px",
                        background:
                          totalVariation > 0
                            ? "rgba(88, 223, 61, 0.78)"
                            : "rgba(233, 75, 75, 0.9)",
                        color: "black",
                      }}
                    >
                      {totalVariation > 0 ? (
                        <BsFillCaretUpFill />
                      ) : (
                        <BsFillCaretDownFill />
                      )}
                      {totalVariation.toFixed(1)}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>

          <tfoot className="table-dark text-center sticky-bottom">
            {(() => {
              const prevYearTotal = {};
              const currYearTotal = {};

              months.forEach((month) => {
                prevYearTotal[month] = 0;
                currYearTotal[month] = 0;
              });

              sections.forEach((section) => {
                const prevData = section.children[0]?.data || [];
                const currData = section.children[1]?.data || [];

                prevData.forEach(({ month_name, total_no_of_crack }) => {
                  prevYearTotal[month_name] += Number(total_no_of_crack) || 0;
                });

                currData.forEach(({ month_name, total_no_of_crack }) => {
                  currYearTotal[month_name] += Number(total_no_of_crack) || 0;
                });
              });

              let grandPrevTotal = 0;
              let grandCurrTotal = 0;

              selectedMonths.forEach((m) => {
                grandPrevTotal += prevYearTotal[m] || 0;
                grandCurrTotal += currYearTotal[m] || 0;
              });

              let totalVariation =
                ((grandCurrTotal - grandPrevTotal) * 100) / grandPrevTotal;
              totalVariation = !isFinite(totalVariation) ? 0 : totalVariation;

              return (
                <tr className="fw-bold text-center">
                  <td className="table-dark">TOTAL</td>

                  {selectedMonths.map((m, j) => (
                    <td key={`tot-prev-${j}`}>{prevYearTotal[m]}</td>
                  ))}

                  <td>{grandPrevTotal}</td>

                  {selectedMonths.map((m, j) => (
                    <td key={`tot-curr-${j}`}>{currYearTotal[m]}</td>
                  ))}

                  <td>{grandCurrTotal}</td>

                  {selectedMonths.map((m, j) => {
                    const prev = prevYearTotal[m] || 0;
                    const curr = currYearTotal[m] || 0;
                    let percentage = ((curr - prev) * 100) / prev;
                    percentage = !isFinite(percentage) ? 0 : percentage;

                    return (
                      <td key={`tot-var-${j}`}>
                        <div
                          className="m-1 text-center p-1"
                          style={{
                            borderRadius: "5px",
                            background:
                              percentage > 0
                                ? "rgba(88, 223, 61, 0.78)"
                                : "rgba(233, 75, 75, 0.9)",
                            color: "black",
                          }}
                        >
                          {percentage > 0 ? (
                            <BsFillCaretUpFill />
                          ) : (
                            <BsFillCaretDownFill />
                          )}
                          {percentage.toFixed(1)}
                        </div>
                      </td>
                    );
                  })}

                  <td>
                    <div
                      className="m-1 text-center p-1"
                      style={{
                        borderRadius: "5px",
                        background:
                          totalVariation > 0
                            ? "rgba(88, 223, 61, 0.78)"
                            : "rgba(233, 75, 75, 0.9)",
                        color: "black",
                      }}
                    >
                      {totalVariation > 0 ? (
                        <BsFillCaretUpFill />
                      ) : (
                        <BsFillCaretDownFill />
                      )}
                      {totalVariation.toFixed(1)}
                    </div>
                  </td>
                </tr>
              );
            })()}
          </tfoot>
        </table>
      </div>

      <DownloadExcel
        tableRef={tableRef}
        fileName={`Crack Month Wise Comparison - ${selectedFy}`}
      />
    </div>
  );
};

export default CrackMonthlyReport;
